import React, { useState, useEffect } from "react";
import AdminFormField from "../../components/Admin/AdminFormField";
import api from "../../services/api";
import "../../styles/Admin.css";

const VisibilityForm = ({ form, onChange, onSubmit, loading }) => {
  const [availableOptions, setAvailableOptions] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [loadingOptions, setLoadingOptions] = useState(false);

  useEffect(() => {
    if (form.type) {
      loadAvailableOptions();
    } else {
      setAvailableOptions([]);
    }
    setSearchTerm("");
    // Reset identifier when type changes
    if (form.identifier) {
      onChange({ ...form, identifier: "" });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [form.type]);

  const loadAvailableOptions = async () => {
    setLoadingOptions(true);
    try {
      let response;
      if (form.type === "region") {
        response = await api.get("/resources/regions");
        setAvailableOptions(
          response.data.map((r) => ({ value: r.slug, label: r.name }))
        );
      } else if (form.type === "os") {
        response = await api.get("/resources/distributions");
        setAvailableOptions(
          response.data.map((d) => {
            // Use slug if available, otherwise use string ID (matches backend logic)
            const identifier = d.slug || String(d.id);
            return {
              value: identifier,
              label: d.name || d.distribution || identifier,
            };
          })
        );
      } else if (form.type === "app") {
        response = await api.get("/resources/applications");
        setAvailableOptions(
          response.data.map((a) => {
            // Use slug if available, otherwise use string ID (matches backend logic)
            const identifier = a.slug || String(a.id);
            return { value: identifier, label: a.name || identifier };
          })
        );
      }
    } catch (error) {
      console.error("Failed to load options:", error);
      setAvailableOptions([]);
    } finally {
      setLoadingOptions(false);
    }
  };

  const filteredOptions = availableOptions.filter(
    (opt) =>
      opt.label.toLowerCase().includes(searchTerm.toLowerCase()) ||
      opt.value.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleOptionSelect = (identifier) => {
    onChange({ ...form, identifier, disabled: true });
    setSearchTerm("");
  };

  return (
    <div className="admin-form mb-3">
      <div className="admin-section-header">
        <h3 className="admin-section-title">Disable Resource from Users</h3>
      </div>

      <div style={{ display: "grid", gap: 16 }}>
        <div>
          <label className="form-label">Step 1: Select Type</label>
          <select
            className="form-control"
            value={form.type}
            onChange={(e) =>
              onChange({ ...form, type: e.target.value, identifier: "" })
            }
          >
            <option value="">-- Select Type --</option>
            <option value="region">Region</option>
            <option value="os">OS (Operating System)</option>
            <option value="app">Application</option>
          </select>
        </div>

        {form.type && (
          <div>
            <label className="form-label">Step 2: Search and Select</label>
            {loadingOptions ? (
              <div className="text-muted" style={{ padding: 12 }}>
                Loading available {form.type} options...
              </div>
            ) : (
              <>
                <input
                  type="text"
                  className="form-control"
                  placeholder={`Search ${form.type}...`}
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  style={{ marginBottom: 8 }}
                />
                {searchTerm && filteredOptions.length > 0 && (
                  <div
                    style={{
                      border: "1px solid #eaeaea",
                      borderRadius: 6,
                      maxHeight: 200,
                      overflowY: "auto",
                      background: "#fff",
                    }}
                  >
                    {filteredOptions.slice(0, 20).map((opt) => (
                      <div
                        key={opt.value}
                        onClick={() => handleOptionSelect(opt.value)}
                        style={{
                          padding: "8px 12px",
                          cursor: "pointer",
                          borderBottom: "1px solid #f5f5f5",
                        }}
                        onMouseEnter={(e) =>
                          (e.currentTarget.style.background = "#fafafa")
                        }
                        onMouseLeave={(e) =>
                          (e.currentTarget.style.background = "#fff")
                        }
                      >
                        <div style={{ fontWeight: 500 }}>{opt.label}</div>
                        <div style={{ fontSize: 12, color: "#666" }}>
                          {opt.value}
                        </div>
                      </div>
                    ))}
                  </div>
                )}
                {form.identifier && (
                  <div
                    style={{
                      marginTop: 8,
                      padding: 8,
                      background: "#f0f9ff",
                      borderRadius: 6,
                      fontSize: 14,
                    }}
                  >
                    Selected: <strong>{form.identifier}</strong>
                  </div>
                )}
              </>
            )}
          </div>
        )}

        {form.identifier && (
          <button
            className="btn-primary"
            onClick={onSubmit}
            disabled={loading || !form.identifier}
            style={{ width: "100%" }}
          >
            {loading ? "Disabling..." : "Disable for Users"}
          </button>
        )}
      </div>
    </div>
  );
};

export default VisibilityForm;
